import React, { useState, useEffect } from "react";
import LeftSideNavigation from "../../../vendorDashboardComponents/navigationSection/LeftSideNavigation";
import HomeReusableTopBarNavigation from "../../superAdminReusable/superAdminHomeButton/HomeReusableTopBarNavigation";
import { Table, Image, Button } from "react-bootstrap";
import SelectFilter from "../../../reusableComponents/selectFilter";
import { NavLink } from "react-router-dom";
import { useHistory } from "react-router";
import moment from "moment";
import { RightSideCountTop } from "../superAdminReports/orderingReports/SuperAdminPendingOrderActivityReports";
import AddReferreePopup from "../../superAdminAllComponent/superAdminRefferalsCode/referralsPopup/AddReferreePopup";
import { amApi } from "../../../../api/apiHelper";
import { isEmpty } from "lodash";

function DunzoStatementRestaurants(props) {
  const [details, setDetails] = useState([]);
  const history = useHistory();

  useEffect(() => {
    async function fetchData() {
      let response = await amApi(`/dunzoMerchants`);
      setDetails(response.data);
    }

    fetchData();
  }, []);

  const RenderTableBody = (data) => (
    <TableBody
      data={data}
      key={data._id}
      dateQuery={history?.location?.state?.dateQuery || {}}
    />
  );

  return (
    <React.Fragment>
      <div className="container-fluid">
        <div className="row">
          <div className="left-side-panel">
            <LeftSideNavigation displayLink={1} />
          </div>
          <div className="super-admin-right-side-panel">
            <HomeReusableTopBarNavigation
              backIcon
              link={`#`}
              displayText="Back"
            />
            <div className="super-admin-inside-right-side-panel">
              <div className="d-flex justify-content-between align-items-center pt-4 pb-3">
                <div className="f24_700_HelveticaNeue">
                  Dunzo restaurant wise statement
                  <br />
                </div>
                <div>
                  <div
                    align="right"
                    style={{ color: "#9E9E9E" }}
                    className="f10-400 my-2"
                  >
                    Report Run Date: {moment().format("LL")}
                  </div>
                </div>
              </div>
              <hr />
              <div className="col-12 p-0 user-table-reusable-superadmin super-admin-all-vendor-main">
                {/* <div className="col-12 p-0 user-table-reusable-superadmin table-responsive"> */}
                <Table className="">
                  <thead>
                    <tr className="super_admin_all_users_table_head">
                      <td style={{ width: "60%" }} className="f12-400">
                        Merchant Name
                      </td>
                      <td style={{ width: "40%" }} className="f12-400">
                        Actions
                      </td>
                    </tr>
                  </thead>
                  {details?.map((data) => RenderTableBody(data))}
                </Table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

const TableBody = ({ data, dateQuery, ...props }) => {
  const [TrDetail, setTrDetail] = useState(false);
  const showTr = () => setTrDetail(!TrDetail);
  const history = useHistory();
  const redirectMerchant = () => {
    history.push(`/dunzosetting/viewstatement`, {
      dateQuery: dateQuery,
      data: data,
      vendor_id: data?.restaurantDetails?.vendor_id,
    });
  };
  return (
    <tbody
      className="w-100 super-admin-all-vendor-main-table-body"
      key={data._id}
    >
      <tr className="w-100 p-0">
        <td className="p-0 w-100">
          <table className="w-100">
            <tbody className="sd_body_css">
              <tr className="sd_body_table-row px-0" onClick={showTr}>
                <td style={{ width: "60%" }}>
                  <div className="f12-500">
                    {data?.restaurantDetails?.restaurant_name || ""}
                  </div>
                </td>
                <td style={{ width: "40%" }}>
                  <button
                    onClick={() => redirectMerchant()}
                    className="enViewDashboard btn btn-outline-danger d-flex align-items-center"
                  >
                    view statement
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </td>
      </tr>
    </tbody>
  );
};

export default DunzoStatementRestaurants;
